module.exports = __webpack_public_path__ + "img/iphone.11805b3d.png";